import script from "./actions-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./actions-dropdown.vue?vue&type=script&setup=true&lang=ts"

import "./actions-dropdown.vue?vue&type=style&index=0&id=a2309d52&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2309d52"]])

export default __exports__